import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';

const Faq = () => {
    const [Accordion, setAccordion] = useState(1)

    const onClickAccordion = ((i) => {
        if (i == Accordion) {
            setAccordion(0)
        } else {
            setAccordion(i)
        }
    });

    const accordionData = [
        {
            title: "Why does it take 2 to 5 business days to complete the plan?",
            desc: " These days represent our investment in the quality of your journey. We don't use generic templates. During this time, I analyze your data in depth and build a plan from scratch, tailored specifically to your goals, lifestyle, and individual body characteristics. This process ensures you begin your journey with the strongest and most suitable plan possible to achieve optimal results."
        },
        {
            title: "What is the refund policy?",
            desc: " You can request a full refund within 24 hours of payment in case of an emergency. This policy allows us to dedicate the necessary time and effort to analyzing your data and designing your customized system from scratch. We guarantee a service and plan that exceeds your expectations."
        },
        {
            title: "What if I don't like a certain type of food? ",
            desc: "Flexibility is the foundation of our dietary plan. Every main meal in your plan comes with a list of healthy, calorie- and macro-counted alternatives. This gives you complete freedom to choose what you prefer each day and ensures you won't get bored or feel pressured to eat anything you don't want. Our main goal is for you to enjoy your journey. "
        },
        {
            title: "How is the plan updated? ",
            desc: "Your plan improves  with you. Before the end of each month of your subscription, you will be asked to fill out a tracking form to update your data, measurements,and any feedback. This new information will then be used to design the next month's plan, with adjustments aimed at breaking any plateaus in results and ensuring your continued progress and development.  "
        },
        {
            title: "What is a follow-up day? ",
            desc: " A follow-up day is your personal point of contact with Dr. Aya to ensure your success. Dr. Aya will contact you via WhatsApp to ask about your adherence to your diet, your energy levels, any challenges you faced, and to answer any questions you may have. The goal is to address problems promptly and celebrate your successes."
        },
        {
            title: "How many kilos can I lose per month? ",
            desc: " This depends on several factors unique to each person, including starting weight,body type, genetics, and level of commitment to the plan. We focus on achieving healthy and sustainable weight loss (often between 0.5 and 2 kilograms per week) rather than rapid and unhealthy weight loss. More important than the number on the scale is building strong habits and noticing changes in body measurements, how clothes fit, and energy levels.  "
        },
        {
            title: "Can I freeze my subscription? ",
            desc: "Yes, absolutely. We understand that life circumstances can change. You can request to freeze your subscription. The available freeze periods are as follows: * 3-month subscription: You can freeze it for two weeks (14 days). * 6-month subscription: You can freeze it for one month (30 days). "
        },
        {
            title: "Will I go back to how I was before my subscription ends?",
            desc: "Our primary goal is to ensure that never happens. Throughout your journey with us, you don't blindly follow a plan; instead, you learn the fundamental principles of proper nutrition and training. You learn how to listen to your body and its needs. We give you the tools and knowledge to make this change a lasting lifestyle. You're not just buying a plan; you're investing in a lifelong education. "
        },
    ]
    return (
        <section>
            <div className="container">
                <div className="row">
                    <div className="col-md-5 my-auto">
                        <h2 className="medium font__size--72 text__70-1024 text__70-md text__70-sm text__70-xxs">FAQ<span className='normal'>s</span></h2>
                        <p className='normal font__size--16 text__16-1024 mb-4'>Maybe your question has been answered,<br /> check this out!</p>
                        <NavLink
                            to="/contact" className="medium font__size--16 text__16-1024 btn btn__purple color__white shadow rounded__24 color__ mb__5">Let's Talk</NavLink>
                    </div>
                    <div className="col-md-7 my-auto">
                        {
                            accordionData.map((obj, i) => {
                                return <div className={"wrapper__accrodion mb-4 " + (Accordion == (i + 1) ? "active" : "")}>
                                    <div className="head pointer" onClick={() => onClickAccordion(i + 1)}>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h4 className='medium font__size--20 text__20-1024 mb-0'>{obj.title}</h4>
                                            <div className="arrow flex-shrink-0">
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="desc">
                                        <p className='mb-0 normal font__size--16 text__16-1024 color__gray-2 lh-2'>{obj.desc}</p>
                                    </div>
                                </div>
                            })
                        }

                    </div>
                </div>
            </div>
        </section>
    )
}

export default Faq